var React = require('react');

function Share (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icons/Navigation/Share White"),React.createElement("g",{"id":"icons/Navigation/Share-White","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","key":1},[React.createElement("path",{"d":"M5,10 L5,18 C5,19.1045695 5.78350169,20 6.75,20 L17.25,20 C18.2164983,20 19,19.1045695 19,18 L19,10 M12,3.375 L12,13.375","id":"Combined-Shape","stroke":"#FFFFFF","strokeWidth":"2","key":0}),React.createElement("polyline",{"id":"Shape","stroke":"#FFFFFF","strokeWidth":"2","points":"16 7.375 12 3.375 8 7.375","key":1})])]);
}

Share.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = Share;

Share.default = Share;
